import React, { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import styles from '../../styles/HomeLanding/HomeLanding.module.css'
import Image from 'next/image'
import QuickWord from './HomeLandingComponents/QuickWord'
import AwardsSection from './HomeLandingComponents/AwardsSection'
import NewFaqSection from './HomeLandingComponents/NewFaqSection'
import OutletsAndBusinesses from './ComponentsIndiaPage/OutletsAndBusinesses'
import CaseStudiesSection from './ComponentsIndiaPage/CaseStudiesSection'
import PosFeatures from './HomeLandingComponents/PosFeatures'
import ReviewsSection from './ComponentsIndiaPage/ReviewsSection'
import IndustryFeaturessIndia from './ComponentsIndiaPage/IndustryFeaturessIndia'
import BusinessUnlockSection from './ComponentsIndiaPage/BusinessUnlockSection'
import AllInOnePOSIndia from './ComponentsIndiaPage/AllInOnePOSIndia'
import NewsAndVideos from './ComponentsIndiaPage/NewsAndVideos'
import TopSection from './ComponentsIndiaPage/TopSection'
import WhyQueueBuster from './ComponentsIndiaPage/WhyQueueBuster'
// VerificationPopup is handled by other pages/components.
import ConnectWithUs from './ComponentsIndiaPage/ConnectWithUs'
import NewsSection from './ComponentsIndiaPage/NewsSection'

const OrbitarySection = dynamic(
    () => import('./ComponentsIndiaPage/OrbitarySection'),
    { ssr: false }
);

const DeferredOrbitarySection = () => {
    const sectionRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        const section = sectionRef.current;
        if (!section || typeof IntersectionObserver === 'undefined') {
            setShouldLoad(true);
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShouldLoad(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '1000px 0px' }
        );

        observer.observe(section);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={sectionRef} style={{ minHeight: '80rem' }}>
            {shouldLoad && <OrbitarySection />}
        </div>
    );
};


const faqs = [
    {
        para: (
            <span style={{ width: "90%" }}>
                What is QueueBuster POS?
            </span>
        ),
        des: (
            <>
                QueueBuster is a <a href="https://queuebuster.co/all-in-one-pos-billing-software">point-of-sale (POS)</a> and <a href="https://queuebuster.co/features/billing-software">billing software</a> for managing invoices, <a href="https://queuebuster.co/features/inventory-management-software">inventory</a>, <a href="https://queuebuster.co/features/customer-loyalty-program">CRM & customer data</a>, <a href="https://queuebuster.co/features/online-store">eStore</a>, <a href="https://queuebuster.co/features/cloud-dashboard-management">reports</a> and more.
            </>
        ),
        id: 1,
        activeIndex: 1,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                Which types of businesses can use QueueBuster?
            </span>
        ),
        des: (
            <>
                <a href="https://queuebuster.co/Industries/retail-pos-billing-software">Retail stores</a>, <a href="https://queuebuster.co/Industries/restaurant-pos-billing-software">restaurants</a>, cafés, <a href="https://queuebuster.co/retail/fashion-apparel-pos-billing-software">apparel shops</a>, <a href="https://queuebuster.co/Industries/grocery-pos-billing-software">grocery stores</a>, <a href="https://queuebuster.co/Industries/electronic-pos-billing-software">electronics retailers</a>, <a href="https://queuebuster.co/Industries/spa-and-salon-pos-billing-software">salons</a>, kiosks, <a href="https://queuebuster.co/D2C-POS-Solutions">D2C brands</a>, <a href="https://queuebuster.co/outlet/theme-park-outlet">amusement parks</a> and thousands of other businesses can use QueueBuster for their business operations. The software fully supports businesses operating across <a href="https://queuebuster.co/enterprise-pos-solution">multiple locations</a>.
            </>
        ),
        id: 2,
        activeIndex: 0,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                How do I get started with QueueBuster?
            </span>
        ),
        des: (
            <>
                Start by installing the QueueBuster app on your <a href="https://queuebuster.co/pos-hardware-partners">point of sale hardware</a> or machine and configuring your business for billing. For setup assistance, email <a href="mailto:contact@queuebuster.co">contact@queuebuster.co</a> or call +91 7861044000.
            </>
        ),
        id: 3,
        activeIndex: 0,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                Which software can I integrate with QueueBuster?
            </span>
        ),
        des: (
            <>
                Over <a href="https://queuebuster.co/pos-software-partners">50+ integrations</a> are possible. You can integrate QueueBuster with leading software and tools such as Tally, Oracle Netsuite, Unicommerce, GYFTR, Microsoft Dynamic, Gupshup, Paytm mLoyal, Nector, <a href="https://queuebuster.co/pos-software-partners/zomato">Zomato</a>, <a href="https://queuebuster.co/pos-software-partners/swiggy">Swiggy</a> and many more.
            </>
        ),
        id: 4,
        activeIndex: 0,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                Which devices can run QueueBuster?
            </span>
        ),
        des: (
            <>
                <a href="https://queuebuster.co/pos-hardware-partners">POS machines</a>, <a href="https://queuebuster.co/pos-payment-partners">Android payment machines</a>, laptops, <a href="https://queuebuster.co/android-pos-billing">Android smartphones and tablets</a>, QueueBuster is compatible with all devices and hardware. Its device-agnostic design supports different hardware formats.
            </>
        ),
        id: 5,
        activeIndex: 0,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                Can I use QueueBuster without buying new hardware?
            </span>
        ),
        des: (
            <>
                Yes. You can run QueueBuster on your existing Android smartphone, tablet, laptop, POS machine or Android payment machine. Its <a href="https://queuebuster.co/pos-hardware-partners">device-agnostic design</a> lets you get started without investing in a new POS device.
            </>
        ),
        id: 6,
        activeIndex: 0,
    },
    {
        para: (
            <span style={{ width: "90%" }}>
                How much does QueueBuster cost?
            </span>
        ),
        des: (
            <>
                <a href="https://queuebuster.co/pricing">Pricing</a> depends on your business requirements. <a href="https://queuebuster.co/contact-us">Request a quote</a> specifying the number of outlets and devices, required features and integrations.
            </>
        ),
        id: 7,
        activeIndex: 0,
    },
]


const HomeLandingPageIndia = () => {
    const imgRef = useRef(null);
    const lastClientPosRef = useRef({ x: 0, y: 0 });
    const lastDeltaRef = useRef({ dx: 0, dy: 0 });
    const lastPointRef = useRef(null);
    const [animate, setAnimate] = useState(false);
    // Exit intent popup is now handled globally in `src/pages/_app.js`.

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setAnimate(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.8 }
        );

        if (imgRef.current) observer.observe(imgRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div
                className={styles.HomeLandingPage}
            >
                  {/* <div className={styles.expoBanner}>
                    <div className={styles.expoBannerScroll}>
                        <div className={styles.expoBannerScrollInner}>
                            <span className={styles.expoBannerEmoji}>🎉</span>
                            Visit QueueBuster POS at IAAPI Amusement Expo 2026 - Booth No. B10, Hall no. 4 |{" "}
                            <a href="https://calendly.com/queuebuster-pos/30min" target="_blank" rel="noopener noreferrer" className={styles.expoBannerLink}>Book Your Slot Now</a>
                        </div>
                    </div>
                  </div> */}
                <div><TopSection /></div>
                <div style={{ margin: "1rem 17rem -2rem 17rem" }}>  <IndustryFeaturessIndia />  </div>
                <div style={{ margin: "6rem 18rem  4rem 18rem" }}><AllInOnePOSIndia /> </div>
                <div style={{ margin: "0rem 18rem" }}><OutletsAndBusinesses /></div>
                <div style={{ margin: "-4rem 18rem 0rem 18rem", }}> <QuickWord /> </div>
                <div style={{ margin: "1rem 18rem", }}>  <WhyQueueBuster />    </div>
                <DeferredOrbitarySection />
                <div><PosFeatures /></div>

                <div className={styles.heineken_section}>
                    <div className={styles.heineken_icon}><Image src='/assets/HomeLanding/heineken.svg' fill  alt='heineken'/></div>
                    <h2> <span> <div ref={imgRef} className={`${styles.isolationImg} ${animate ? styles.animateIn : ''}`} >  <Image src="/assets/HomeLanding/Isolation_Mode.webp" fill alt="Isolation Mode" /></div>
                        We explored numerous POS solutions for our pubs and</span> <br /> grocery stores, but none provided us with the ideal fit <br />until we discovered QueueBuster. The QueueBuster POS <br />solution is highly flexible and reasonably priced.</h2>

                    <div className={styles.avatar_heineken}><Image src='/assets/HomeLanding/Avatar.svg' fill  alt='Avatar image'/></div>
                    <p style={{margin:'1rem 0 -1rem 0'}}>Chima Uba</p>
                    <p>Head,Digital Products & Transformation | Heineken, Nigeria</p>
                </div>
                <div ><AwardsSection /> </div>
                <div ><ReviewsSection /></div>
                <div><BusinessUnlockSection /></div>
                <div ><CaseStudiesSection /></div>

                <div style={{margin:"0 0rem 8rem 0rem "}}> <ConnectWithUs/></div>
            
                <div className={styles.faqSection}> <NewFaqSection FaqTableData={faqs} /></div>


                {/* -------------Contact specialist ----------------- */}
                {/* <div style={{ textAlign: "center", }}>

                <h2  className={styles.contactTitle}>Anything else on your mind?</h2>
                <p style={{ fontFamily: "GilroyRegular" }}>Can’t find what you need? Let our expert team help you. </p>
                <Button className={styles.Connect_specialist_btn} >Connect with a specialist</Button>
            </div> */}

                {/* ---------------constact us ----------- */}
                {/* <div style={{ margin: "10rem 0" }}>
                <div id='enterpriseForm'>
                    <NewDesktopEntpForm usedIn='enterprise page' verified={userVerified} />

                </div>
            </div> */}

                {/* <div > <NewsAndVideos /> </div> */}
               
            </div>
            {/* <div><FooterIndia /></div> */}
            <div > <NewsSection /> </div>
        </>
    )
}

export default HomeLandingPageIndia
